var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"alt":_vm.user.name,"src":_vm.avatarSrc}})
}
var staticRenderFns = []

export { render, staticRenderFns }